import { createReducer, on } from '@ngrx/store';

// Interfaces
import { ICards } from '@interfaces/stripe-card.interface';

// Actions
import {
  clearPaymentCards,
  loadPaymentCards,
  loadPaymentCardsSuccess,
  loadPaymentCardsError,
  addNewCard,
  updateSelectedCard,
  deleteCardSuccess,
  deleteCardError,
} from './payments.actions';

export const paymentsFeatureKey = 'payments';

export interface IPaymentsState {
  cards: ICards | null;
  isFetching: boolean;
  isError: boolean;
}

export const initialState: IPaymentsState = {
  cards: null,
  isFetching: false,
  isError: false,
};

export const paymentsReducer = createReducer(
  initialState,
  on(clearPaymentCards, () => ({
    cards: null,
    isFetching: false,
    isError: false,
  })),
  on(loadPaymentCards, state => ({
    ...state,
    isError: false,
    isFetching: true,
  })),
  on(loadPaymentCardsSuccess, (state, { cards }) => ({
    cards,
    isError: false,
    isFetching: false,
  })),
  on(loadPaymentCardsError, state => ({
    ...state,
    isError: true,
    isFetching: false,
  })),
  on(addNewCard, (state, { card }) => {
    if (!state.cards) {
      return state;
    }

    return {
      cards: {
        ...state.cards,
        cards: [...state.cards.cards, card],
      },
      isError: true,
      isFetching: false,
    };
  }),
  on(updateSelectedCard, (state, { cardId }) => {
    if (!state.cards) {
      return state;
    }

    return {
      cards: {
        ...state.cards,
        selected_card: cardId,
      },
      isError: true,
      isFetching: false,
    };
  }),
  on(deleteCardSuccess, (state, { cardId }) => {
    if (!state.cards) {
      return state;
    }

    const prev = state.cards;
    const nextCards = prev.cards.filter(card => card.id !== cardId);
    const nextSelected = nextCards.length === 0 ? '' : prev.selected_card;

    return {
      cards: {
        ...prev,
        cards: nextCards,
        selected_card: nextSelected,
      },
      isError: true,
      isFetching: false,
    };
  }),
  on(deleteCardError, state => ({
    ...state,
    isError: true,
    isFetching: false,
  })),
);
